import { FileDocumentCheckIcon } from './FileDocumentCheckIcon';

/**
 * author: Simran
 * id F51E0270-13FD-4DA5-945B-FE8C4C45AF60
 * name file-document-check
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-check.svg
 * tags
 * - Files / Folders 
 */
export const FileTextCheckIcon = FileDocumentCheckIcon;
export default FileTextCheckIcon